import { Card } from '../../../layout/Card.jsx';
import { Pill } from '../../../layout/Pill.jsx';
import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD, formatDateTime } from '../../../shared/format.js';

// الفواتير المعلّقة — تقرأ من /reports/pending-invoices الذي يُرجع
// { rows, count, totalDue, totalBilled }. القائمة مربوطة بحالة الفاتورة
// الحقيقية (pending/partial)، فتختفي الفاتورة فور دفعها أو إلغائها،
// وتظهر الجديدة فور إنشائها (أحداث المقبس تُبطل استعلام اللوحة).

export function normalizePending(data) {
  const arr = Array.isArray(data) ? data : data?.rows || data?.items || data?.data || [];
  return arr.map((r, i) => ({
    id: r.id ?? r._id ?? `p-${i}`,
    number: r.number || '—',
    customerName: r.customerName || r.childName || r.guardianName || 'زبون نقدي',
    posTypeLabel: r.posTypeLabel || r.posType || '—',
    status: r.paymentStatus || 'pending',
    createdAt: r.createdAt,
    grandTotal: Number(r.grandTotal || 0),
    paidAmount: Number(r.paidAmount || 0),
    // المستحق هو ما يهمّ هنا: الفاتورة الجزئية معلّقة ببقيتها لا بكاملها.
    dueAmount: Number(r.dueAmount ?? (Number(r.grandTotal || 0) - Number(r.paidAmount || 0)))
  }));
}

export function PendingInvoicesPanel({ data, limit = 8 }) {
  const rows = normalizePending(data);
  const totalDue = data?.totalDue != null
    ? Number(data.totalDue)
    : rows.reduce((s, r) => s + r.dueAmount, 0);
  const count = data?.count != null ? Number(data.count) : rows.length;

  return (
    <Card
      header="الفواتير المعلّقة"
      sub={`${count} فاتورة مفتوحة — إجمالي المستحق ${formatIQD(totalDue)}`}
    >
      <div data-testid="pending-invoices-panel">
        {rows.length === 0 ? (
          <div className="px-4 py-10 text-center text-ink-3 text-sm flex flex-col items-center gap-2">
            <Icon name="check" size={28} color="#22C55E" />
            لا توجد فواتير معلّقة
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-[13px]">
              <thead>
                <tr className="text-ink-3 text-[11.5px] uppercase tracking-wider">
                  <th className="text-right font-semibold py-2 px-3">رقم الفاتورة</th>
                  <th className="text-right font-semibold py-2 px-3">الوقت</th>
                  <th className="text-right font-semibold py-2 px-3">الزبون</th>
                  <th className="text-right font-semibold py-2 px-3">القسم</th>
                  <th className="text-right font-semibold py-2 px-3">الإجمالي</th>
                  <th className="text-right font-semibold py-2 px-3">المستحق</th>
                  <th className="text-right font-semibold py-2 px-3">الحالة</th>
                </tr>
              </thead>
              <tbody>
                {rows.slice(0, limit).map((r) => (
                  <tr key={r.id} className="border-t border-line">
                    <td className="py-2 px-3 font-mono text-[11.5px]">{r.number}</td>
                    <td className="py-2 px-3 text-ink-3 text-[11.5px]">
                      {r.createdAt ? formatDateTime(r.createdAt) : '—'}
                    </td>
                    <td className="py-2 px-3 font-semibold">{r.customerName}</td>
                    <td className="py-2 px-3">{r.posTypeLabel}</td>
                    <td className="py-2 px-3">{formatIQD(r.grandTotal)}</td>
                    <td className="py-2 px-3 font-bold text-orange-deep">{formatIQD(r.dueAmount)}</td>
                    <td className="py-2 px-3">
                      {r.status === 'partial' ? (
                        <Pill variant="warning">مدفوعة جزئياً</Pill>
                      ) : (
                        <Pill variant="orange">معلّقة</Pill>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
              {rows.length > limit ? (
                <tfoot>
                  <tr>
                    <td colSpan={7} className="py-2 px-3 text-ink-3 text-[11.5px]">
                      {`و${rows.length - limit} فاتورة معلّقة أخرى`}
                    </td>
                  </tr>
                </tfoot>
              ) : null}
            </table>
          </div>
        )}
      </div>
    </Card>
  );
}
